<div class="about-page">
	<div class="container container--mobile-padding" *ngIf="title || text">
		<div class="about-page__image">
			<img src="./assets/images/about-2--desktop.jpg"
				 class="visible-desktop"
				 alt="{{title}}"
				 title="{{title}}" />

			<img src="./assets/images/about-2--tablet.jpg"
				 class="visible-tablet"
				 alt="{{title}}"
				 title="{{title}}" />

			<img src="./assets/images/about-2--mobile.jpg"
				 class="visible-mobile"
				 alt="{{title}}"
				 title="{{title}}" />
		</div>
	</div>

	<div class="container container--mobile-padding-more">
		<h2 *ngIf="title" [innerHTML]="title"></h2>
		<p *ngIf="text" [innerHTML]="text"></p>

		<div class="awards-list" *ngIf="awardsData">
			<div class="awards-list__item" *ngFor="let award of awardsData">
				<div class="awards-list__img">
					<img src="{{award.image}}"
						 alt="{{award.name}}"
						 title="{{award.name}}">
				</div>
				<span [innerHTML]="award.name"></span>
				<br><b [innerHTML]="award.year"></b>
			</div>
		</div>
	</div>

	<div class="container container--mobile-padding-more" *ngIf="historyData">
		<div class="histiry-block">
			<h2>{{ "ABOUT.HISTORY" | translate }}</h2>

			<ng-container *ngFor="let event of historyData">
				<div class="histiry-block__item" *ngIf="event.event">
					<div class="histiry-block__year">{{event.year}}</div>
					<p [innerHTML]="event.event"></p>
				</div>
			</ng-container>
		</div>
	</div>
</div>
